// extracted by mini-css-extract-plugin
export default {"pageContainer":"Wallet_pageContainer__SMr6D","walletList":"Wallet_walletList__sVYg8","walletCard":"Wallet_walletCard__Q3AD0","walletImage":"Wallet_walletImage__07DZM"};